import type { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_TRAVELSHOOT_CREDIT_HASH,
} from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { layout, benefit, benefitLabel } = props

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="travelshoot_credit"
    heading={<FormattedMessage
      defaultMessage="{amount} Travelshoot voucher"
      id="7_XuZ3RInsOpoRHzyyrA"
      description="Heading for loyalty Travelshoot photo credit benefit tile showing voucher value"
      values={{ amount: <FormatCurrency value={benefit.value?.amount ?? 0} format="dynamic" /> }}
    />}
    subtitle={benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_TRAVELSHOOT_CREDIT_HASH)}
  />
}

export default LandingPageLoyaltyTravelShootCredit
